var map = {
	"./Hepsiburada.png": "f180",
	"./N11.png": "4f2d",
	"./Toptan.png": "f2fc",
	"./Trendyol.png": "f801",
	"./favicon.png": "6d55",
	"./logo.png": "a4ef"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "818c";